export default "/images/bfa24a697a08864e455848713daa9e5f.avif";